<script type="ts">
	import Bottom from '$theme/Bottom.svelte';
	import Top from '$theme/Top.svelte';

	type Meta = {
		title: string;
		description: string;
	};
	
	export let title: string;
	export let meta: Meta | undefined;
</script>

<svelte:head>
	<title>{meta?.title || title} | On Writing Code</title>
	{#if meta?.title}
		<meta name="title" content={meta.title} />
	{/if}
	{#if meta?.description}
		<meta name="description" content={meta.description} />
	{/if}
</svelte:head>

<Top>
	<div class="grid content">
		<h1>{title}</h1>
	</div>
</Top>
<div class="grid content">
	<slot />
</div>
<Bottom />

<style lang="scss">
	h1 {
		text-align: left;
		font-size: 2.5rem;
		padding-top: 10vh;
	}
</style>
